
import axios from 'axios'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import backendUrl from '../../apiConfig';


const initialTemplates = [
    {
        id: 'cyberpunkNight',
        name: 'Cyberpunk Night',
        preview: {
            background: 'bg-gradient-to-b from-purple-900 via-pink-700 to-orange-600',
            buttons: [
                'bg-cyan-400/20 hover:bg-cyan-400/30 text-cyan-300 border border-cyan-500 backdrop-blur-sm',
                'bg-pink-400/20 hover:bg-pink-400/30 text-pink-300 border border-pink-500 backdrop-blur-sm',
                'bg-yellow-400/20 hover:bg-yellow-400/30 text-yellow-300 border border-yellow-500 backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'forestMist',
        name: 'Forest Mist',
        preview: {
            background: 'bg-gradient-to-b from-green-800 to-green-600',
            buttons: [
                'bg-white/10 hover:bg-white/20 text-green-100 border border-green-300 backdrop-blur-md',
                'bg-white/10 hover:bg-white/20 text-green-100 border border-green-300 backdrop-blur-md',
                'bg-white/10 hover:bg-white/20 text-green-100 border border-green-300 backdrop-blur-md'
            ]
        }
    },
    {
        id: 'desertSunset',
        name: 'Desert Sunset',
        preview: {
            background: 'bg-gradient-to-b from-orange-500 via-red-500 to-purple-800',
            buttons: [
                'bg-yellow-500/30 hover:bg-yellow-500/40 text-white border border-yellow-400 backdrop-blur-sm',
                'bg-yellow-500/30 hover:bg-yellow-500/40 text-white border border-yellow-400 backdrop-blur-sm',
                'bg-yellow-500/30 hover:bg-yellow-500/40 text-white border border-yellow-400 backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'arcticFrost',
        name: 'Arctic Frost',
        preview: {
            background: 'bg-gradient-to-b from-blue-100 to-blue-300',
            buttons: [
                'bg-white/60 hover:bg-white/70 text-blue-900 border border-blue-200 backdrop-blur-sm',
                'bg-white/60 hover:bg-white/70 text-blue-900 border border-blue-200 backdrop-blur-sm',
                'bg-white/60 hover:bg-white/70 text-blue-900 border border-blue-200 backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'tropicalParadise',
        name: 'Tropical Paradise',
        preview: {
            background: 'bg-gradient-to-b from-green-400 via-blue-500 to-purple-600',
            buttons: [
                'bg-yellow-300/30 hover:bg-yellow-300/40 text-white border border-yellow-200 backdrop-blur-sm',
                'bg-pink-300/30 hover:bg-pink-300/40 text-white border border-pink-200 backdrop-blur-sm',
                'bg-blue-300/30 hover:bg-blue-300/40 text-white border border-blue-200 backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'vintagePaper',
        name: 'Vintage Paper',
        preview: {
            background: 'bg-amber-100',
            buttons: [
                'bg-amber-200 hover:bg-amber-300 text-amber-900 border border-amber-400',
                'bg-amber-200 hover:bg-amber-300 text-amber-900 border border-amber-400',
                'bg-amber-200 hover:bg-amber-300 text-amber-900 border border-amber-400'
            ]
        }
    },
    {
        id: 'neonDreams',
        name: 'Neon Dreams',
        preview: {
            background: 'bg-gray-900',
            buttons: [
                'bg-pink-500/20 hover:bg-pink-500/30 text-pink-300 border border-pink-500 shadow-[0_0_10px_rgba(236,72,153,0.5)]',
                'bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 border border-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.5)]',
                'bg-purple-500/20 hover:bg-purple-500/30 text-purple-300 border border-purple-500 shadow-[0_0_10px_rgba(168,85,247,0.5)]'
            ]
        }
    },
    {
        id: 'minimalistZen',
        name: 'Minimalist Zen',
        preview: {
            background: 'bg-gray-50',
            buttons: [
                'bg-white hover:bg-gray-100 text-gray-800 border border-gray-200',
                'bg-white hover:bg-gray-100 text-gray-800 border border-gray-200',
                'bg-white hover:bg-gray-100 text-gray-800 border border-gray-200'
            ]
        }
    },
    {
        id: 'cosmicVoyage',
        name: 'Cosmic Voyage',
        preview: {
            background: 'bg-gradient-to-b from-indigo-900 via-purple-900 to-pink-800',
            buttons: [
                'bg-white/10 hover:bg-white/20 text-purple-200 border border-purple-400 backdrop-blur-md',
                'bg-white/10 hover:bg-white/20 text-purple-200 border border-purple-400 backdrop-blur-md',
                'bg-white/10 hover:bg-white/20 text-purple-200 border border-purple-400 backdrop-blur-md'
            ]
        }
    },
    {
        id: 'autumnHarvest',
        name: 'Autumn Harvest',
        preview: {
            background: 'bg-gradient-to-b from-orange-400 via-red-500 to-yellow-600',
            buttons: [
                'bg-amber-700/30 hover:bg-amber-700/40 text-amber-100 border border-amber-400 backdrop-blur-sm',
                'bg-amber-700/30 hover:bg-amber-700/40 text-amber-100 border border-amber-400 backdrop-blur-sm',
                'bg-amber-700/30 hover:bg-amber-700/40 text-amber-100 border border-amber-400 backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'marvel',
        name: 'Marvel',
        preview: {
            background: 'bg-yellow-400',
            buttons: [
                'bg-red-600 hover:bg-red-700 text-white font-bold border-2 border-black',
                'bg-red-600 hover:bg-red-700 text-white font-bold border-2 border-black',
                'bg-red-600 hover:bg-red-700 text-white font-bold border-2 border-black'
            ]
        }
    },
    {
        id: 'seaSide',
        name: 'Sea Side',
        preview: {
            background: 'bg-gradient-to-b from-blue-400 to-blue-600',
            buttons: [
                'bg-white/30 hover:bg-white/40 text-white backdrop-blur-sm',
                'bg-white/30 hover:bg-white/40 text-white backdrop-blur-sm',
                'bg-white/30 hover:bg-white/40 text-white backdrop-blur-sm'
            ]
        }
    },
    {
        id: 'darkBasic',
        name: 'Dark Basic',
        preview: {
            background: 'bg-black',
            buttons: [
                'border border-gray-700 bg-black hover:bg-gray-900 text-gray-300',
                'border border-gray-700 bg-black hover:bg-gray-900 text-gray-300',
                'border border-gray-700 bg-black hover:bg-gray-900 text-gray-300'
            ]
        }
    },
    {
        id: 'lightBasic',
        name: 'Light Basic',
        preview: {
            background: 'bg-white',
            buttons: [
                'border border-gray-200 bg-white hover:bg-gray-50 text-gray-800',
                'border border-gray-200 bg-white hover:bg-gray-50 text-gray-800',
                'border border-gray-200 bg-white hover:bg-gray-50 text-gray-800'
            ]
        }
    },

    {
        id: 'purpleGradient',
        name: 'Purple Gradient',
        preview: {
            background: 'bg-gradient-to-b from-purple-500 to-purple-900',
            buttons: [
                'bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border border-white/30',
                'bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border border-white/30',
                'bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border border-white/30'
            ]
        }
    },
    {
        id: 'flowtingGlow',
        name: 'Floating Glow',
        preview: {
            background: 'bg-gradient-to-b from-blue-900 to-black',
            buttons: [
                'bg-white/10 backdrop-blur-md hover:bg-white/20 text-white border border-white/20',
                'bg-white/10 backdrop-blur-md hover:bg-white/20 text-white border border-white/20',
                'bg-white/10 backdrop-blur-md hover:bg-white/20 text-white border border-white/20'
            ]
        }
    },
];




// const complexTemplates = [
//     {
//         id: 'intoTheMatrix',
//         name: 'Into The Matrix',
//         buttonStyle: 'bg-black hover:bg-gray-800 text-green-500 border border-green-500 hover:shadow-[0_0_10px_rgba(34,197,94,0.5)] transition-all duration-300'
//     },
//     {
//         id: 'stanLee',
//         name: 'Stan Lee',
//         buttonStyle: 'bg-red-600 hover:bg-red-700 text-white font-bold border-2 border-black hover:shadow-[0_0_10px_rgba(0,0,0,0.5)] transition-all duration-300'
//     },
//     {
//         id: 'codexInventorum',
//         name: 'Codex Inventorum',
//         buttonStyle: 'bg-amber-100 hover:bg-amber-200 text-brown-800 border border-amber-900 font-serif transition-all duration-300'
//     },
//     {
//         id: 'terminal',
//         name: 'Terminal',
//         buttonStyle: 'bg-black hover:bg-gray-800 text-green-500 font-mono border border-green-500 hover:shadow-[0_0_10px_rgba(34,197,94,0.5)] transition-all duration-300'
//     },
//     {
//         id: 'retroNeon',
//         name: 'Retro Neon',
//         buttonStyle: 'bg-purple-900 hover:bg-purple-800 text-cyan-400 border border-cyan-500 shadow-[0_0_10px_rgba(34,211,238,0.5)] hover:shadow-[0_0_15px_rgba(34,211,238,0.7)] transition-all duration-300'
//     },
//     {
//         id: 'hogwarts',
//         name: 'Hogwarts',
//         buttonStyle: 'bg-gradient-to-r from-red-900 to-yellow-900 hover:from-red-800 hover:to-yellow-800 text-yellow-300 border border-yellow-600 font-serif transition-all duration-300'
//     },
// ];





export default function TemplateSelection() {
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const navigate = useNavigate()

    const handleTemplateSelect = async (templateId) => {
        setSelectedTemplate(templateId)
        const token = localStorage.getItem("jwtToken")

        try {
            await axios.post(
                `${backendUrl}/links/template`,
                { data: { template: templateId } },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            navigate("/links")
        } catch (err) {
            console.error("Error setting template:", err)
        }
    }

    const handleSkip = () => {
        navigate("/links")
    }

    return (
        <div className="min-h-screen bg-white">
            {/* Progress bar */}
            <div className="fixed top-0 left-0 z-50 right-0 h-1 bg-gray-100">
                <div className="h-full bg-purple-500 w-1/4" />
            </div>

            {/* Skip button */}
            <div className="flex justify-between items-center mb-4">
                <button
                    onClick={handleSkip}
                    className="fixed top-4 right-4 text-sm font-medium text-gray-600 hover:text-gray-900"
                >
                    Skip
                </button>
            </div>

            <div className="max-w-5xl mx-auto px-4 py-16">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold mb-4">Select a template</h1>
                    <p className="text-gray-600">
                        Pick the style that feels right - you can add your content later
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {initialTemplates.map((template) => (
                        <div
                            key={template.id}
                            className={`relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg border ${selectedTemplate === template.id ? 'ring-2 ring-black' : 'border-gray-200'
                                }`}
                            onClick={() => handleTemplateSelect(template.id)}
                        >
                            {/* Preview */}
                            <div className={`aspect-[9/16] ${template.preview.background}`}>
                                {/* Profile Header */}
                                <div className="p-6 text-center">
                                    <div className="w-16 h-16 bg-white/20 rounded-full mx-auto mb-3" />
                                    <div className="h-4 w-24 bg-white/20 rounded mx-auto mb-2" />
                                    <div className="h-3 w-32 bg-white/10 rounded mx-auto" />
                                </div>

                                {/* Buttons */}
                                <div className="px-4 space-y-3">
                                    {template.preview.buttons.map((buttonStyle, i) => (
                                        <div
                                            key={i}
                                            className={`h-12 rounded-lg ${buttonStyle}`}
                                        />
                                    ))}
                                </div>
                            </div>

                            {/* Template Name */}
                            <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm p-3 border-t border-gray-200">
                                <h3 className="font-medium text-black text-sm text-center">{template.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <button
                        onClick={handleSkip}
                        className="text-sm text-gray-500 hover:text-gray-900"
                    >
                        I'll customize this later
                    </button>
                </div>
            </div>
        </div>
    )
}